// OIDC redirect-callback handler. Keycloak redirects here with ?code=...&state=...
// We complete the code exchange, then route to wherever the user was headed.

import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { userManager } from "./oidc";

export function CallbackPage() {
  const nav = useNavigate();
  const [error, setError] = useState<string | null>(null);
  const called = useRef(false);

  useEffect(() => {
    // Guard against React StrictMode double-invoke: signinRedirectCallback()
    // consumes the PKCE state from sessionStorage on first call; a second call
    // would hit KC with an already-used code and get "Code not valid".
    if (called.current) return;
    called.current = true;

    userManager
      .signinRedirectCallback()
      .then((user) => {
        const returnTo = (user.state as { returnTo?: string } | undefined)?.returnTo;
        nav(returnTo && returnTo !== "/login" ? returnTo : "/", { replace: true });
      })
      .catch((e: unknown) => {
        setError(e instanceof Error ? e.message : "Sign-in failed");
      });
  }, [nav]);

  if (error) {
    return (
      <div className="login-shell">
        <div className="login-card">
          <div className="login-error">Sign-in failed: {error}</div>
          <button className="btn-primary login-submit" onClick={() => nav("/login", { replace: true })}>
            Back to sign in
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="loading">
      <div className="loading-spinner" />
      <p>Completing sign-in…</p>
    </div>
  );
}
